import styled from 'styled-components';

export const NotFound = styled.div`
  background: #ededed;
  height: 100vh;
`;
